import { WeightUnit } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import * as z from "zod";

export const updateOmsApparelMagicIntegration = {
  name: "updateOmsApparelMagicIntegration" as const,
  input: z.object({
    usePickTicketNumberAsOrderName: z.boolean().optional(),
    autoInvoicePickTickets: z.boolean().optional(),
    defaultWeightUnit: z.nativeEnum(WeightUnit).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
